const notice = document.querySelector('.section-notice');
const header = document.querySelector('header');
const level2Elems = document.querySelectorAll('.level-2');
const mobileMenu = document.querySelector('.mobile-menu');
const closeBtn = document.querySelector('#close-notice');

if (!notice) return;

let headerHeight = header.clientHeight;

// add smooth transition for dropdowns and mobile menu
level2Elems.forEach(el => el.style.transition = 'top 1s ease');
if (mobileMenu) mobileMenu.style.transition = 'inset 1s ease, height 1s ease';

// function to update dropdown top, mobile menu inset & height, mm-stack max-height
function updatePositions() {
    const noticeHeight = notice ? notice.clientHeight : 0;
    const totalTop = headerHeight + noticeHeight;

    // update level-2 dropdowns
    level2Elems.forEach(el => el.style.top = totalTop + 'px');

    // update mobile menu only on small screens
    if (window.innerWidth <= 1600 && mobileMenu) {
        mobileMenu.style.inset = `${totalTop}px 0 0 auto`;
        mobileMenu.style.height = `calc(100vh - ${totalTop}px)`;

        // update .mm-stack max-height dynamically
        const mmStack = mobileMenu.querySelector('.mm-stack');
        if (mmStack) {
            mmStack.style.maxHeight = `calc(100vh - ${totalTop}px)`;
            mmStack.style.overflowY = 'auto'; // enable scrolling if content is too tall
        }
    }
}

// slide up the notice
function slideUp() {
    if (!notice) return;

    const noticeHeight = notice.clientHeight;
    notice.style.marginTop = -noticeHeight + 'px';

    // move level-2 dropdowns smoothly up
    level2Elems.forEach(el => el.style.top = headerHeight + 'px');

    // move mobile menu smoothly up and adjust height
    if (window.innerWidth <= 1600 && mobileMenu) {
        mobileMenu.style.inset = `${headerHeight}px 0 0 auto`;
        mobileMenu.style.height = `calc(100vh - ${headerHeight}px)`;

        const mmStack = mobileMenu.querySelector('.mm-stack');
        if (mmStack) {
            mmStack.style.maxHeight = `calc(100vh - ${headerHeight}px)`;
        }
    }

    setTimeout(() => notice.remove(), 1000); // remove notice after animation
}

// check if notice already closed
if (localStorage.getItem(notice.id) === 'closed') {
    notice.remove();
    updatePositions();
} else {
    updatePositions();

    closeBtn?.addEventListener('click', () => {
        slideUp();
        localStorage.setItem(notice.id, 'closed');
    });

    // optional auto-slide
    // setTimeout(() => { slideUp(); localStorage.setItem(notice.id, 'closed'); }, 10000);
}

// update on window resize
window.addEventListener('resize', () => {
    headerHeight = header.clientHeight;
    updatePositions();
});

// observe notice height changes
if (notice) {
    new ResizeObserver(updatePositions).observe(notice);
}
